/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns true if the current user is anonymous.
 *
 * @agent-skills: tenant-context
 */
export const useIsAnonymous = (): boolean => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.isAnonymous;
};
